// extracted by mini-css-extract-plugin
module.exports = {"title":"BarTitle_title__2Vf2e"};